import request from "../api";

function getModuleData() {
  return request({
    url: "/vji/public/calendar2/action=moduledata",
    method: "GET",
  });
}

function getDataList({ start, end }) {
  return request({
    url: `/vji/public/calendar2/action=datalist/start=${start}/end=${end}`,
    method: "GET",
  });
}

function getDataDetails({ hexkey }) {
  return request({
    url: `/vji/public/calendar2/action=detaildata/gd=${hexkey}`,
    method: "GET",
  });
}

const publicCalendarService = {
  getModuleData,
  getDataList,
  getDataDetails,
};

export default publicCalendarService;
